import {Component, Input, OnChanges, SimpleChange, AfterViewInit, Output, EventEmitter} from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import {Funcoes} from "../../funcoes";
import {FileUploaderCustom} from "app/shared/file-upload-custom";

declare let $:any;

@Component({
  selector: 'widget-file-upload',
  template: ` <div
                [formGroup]="form"
                [class.has-error]="form.controls[id]?.touched && !form.controls[id]?.valid"
                [class.has-feedback]="form.controls[id]?.touched && !form.controls[id]?.valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  <input *ngIf="multiple"
                    type="file"
                    id="{{id}}"
                    formControlName="{{id}}"
                    ng2FileSelect
                    [uploader]="uploader"
                    (change)="uploadFiles()"
                    [disabled]="readonly"
                    [attr.accept]="accept"
                    multiple />
                  <input *ngIf="!multiple"
                    type="file"
                    id="{{id}}"
                    formControlName="{{id}}"
                    ng2FileSelect
                    [uploader]="uploader"
                    (change)="uploadFiles()"
                    [disabled]="readonly"
                    [attr.accept]="accept"/>
                  <span *ngIf="!readonly">
                    <div *ngFor="let item of uploader.queue">
                      <div class="progress">
                        <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }">
                          <span class="sr-only" style="position: relative;">{{ item?.file?.name }} - {{item.progress}}%</span>
                        </div>
                      </div>
                    </div>
                  </span>
                  
                  <span class="help-block" *ngIf="form.controls[id]?.touched && !form.controls[id]?.valid && !form.controls[id]?.errors[id]">{{txt_default_erro}}</span>
                  <div *ngIf="form.controls[id] && !form.controls[id].valid">
                    <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                  </div>
                </div>
              </div>`,
})

export class WidgetFileUpload implements OnChanges, AfterViewInit {

  @Input()
  id: string = '';

  @Input()
  accept: string = '';

  @Input()
  url: any;

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  multiple: boolean = false;

  @Input()
  formData: object = {};

  @Output() uploadComplete = new EventEmitter<any>();

  //public uploader: FileUploader;
  public uploader: FileUploaderCustom;
  public hasBaseDropZoneOver:boolean = false;
  public hasAnotherDropZoneOver:boolean = false;

  constructor(protected func: Funcoes){
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}) {
    console.log('changes', changes);
    for (let change in changes) {
      if(change == 'url' || change == 'formData'){
        this.uploader = new FileUploaderCustom({
          url: this.url,
          authToken: localStorage.getItem('token'),
          itemAlias: this.id,
          additionalParameter: this.formData
        });

        $("#"+this.id).attr('disabled', this.readonly);
        $.uniform.update();

        this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
          this.onComplete(item, response, status, headers);
        };
      }
    }
  }

  ngAfterViewInit() {
    this.uploader = new FileUploaderCustom({
      url: this.url,
      authToken: localStorage.getItem('token'),
      itemAlias: this.id,
      additionalParameter: this.formData
    });

    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
      this.onComplete(item, response, status, headers);
    };

    $("#"+this.id).attr('disabled', this.readonly);

    $("#"+this.id).uniform({
      wrapperClass: 'bg-primary',
      fileButtonHtml: '<i class="icon-plus3"></i>'
    });
  }

  onComplete(item:any, response:any, status:any, headers:any){

    //console.log('resposta', response);
    this.uploadComplete.emit(response);

    let self = this;
    setTimeout(function () {
      self.uploader.clearQueue();
    },3000);
  }

  uploadFiles(){
    if(!this.readonly){
      if(this.multiple){
        this.uploader.uploadAllFiles();
      }else{
        this.uploader.uploadAll();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-file-upload.ts